import { useTranslations } from "../../hooks/useTranslations";

type EmptyStateProps = {
  message: string;
  onClearFilters?: () => void;
};

export function EmptyState({ message, onClearFilters }: EmptyStateProps) {
  const t = useTranslations();

  return (
    <div className="festapp-empty-state">
      <svg
        className="festapp-empty-state-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
        <line x1="8" y1="11" x2="14" y2="11" />
      </svg>
      <p className="festapp-empty-state-message">{message}</p>
      <p className="festapp-empty-state-hint">{t.emptyStateHint}</p>
      {onClearFilters && (
        <button
          type="button"
          className="festapp-btn festapp-btn-secondary festapp-btn-sm"
          onClick={onClearFilters}
        >
          {t.clearFilters}
        </button>
      )}
    </div>
  );
}
